import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.automatedLendingDecision.decisionError.wrongDirectorDetailsError.title',
        defaultMessage: 'Do your details look right?'
    },
    message: {
        id: '_.automatedLendingDecision.decisionError.wrongDirectorDetailsError.message',
        defaultMessage:
            "We weren't able to run our checks - can you double {messageCheckDetailsLink} you gave? Then we'll take another look."
    },
    messageCheckDetailsLink: {
        id: '_.automatedLendingDecision.decisionError.wrongDirectorDetailsError.messageCheckDetailsLink',
        defaultMessage: 'check the details'
    }
});
